<template>
  <div ref="seatAvailabilityTableRef">
    <div>
      <table class="table" id="datatable">
        <thead>
          <tr>
            <th>Seats</th>
            <th v-for="(slot, index) in seats[0].hasAvailableSlots.slice(0, displaySlots)" :key="index">
              <span v-if="index === 0">Now: {{ slot.time }}</span>
              <span v-else>{{ slot.time }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-for="(seat,i) in seats" :index="i" :key="i">
          <tr>
            <td>{{ seat.name }}</td>
            <td v-for="(slot, index) in seat.hasAvailableSlots.slice(0, displaySlots)" :key="index">
                <v-icon v-if="slot.isAvail" color="green" slot="prepend-inner">mdi-seat</v-icon>
                <v-icon v-else color="red" slot="prepend-inner">mdi-cancel</v-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import LoginIcon from "@/components/LoginIcon";

  export default {
    name: 'SeatAvailabilityTable', 
    props: ['seats', 'index', 'displaySlots'],
    components: {
      LoginIcon,
    }  
  };
</script>

<style scoped>
  table, td, th {
    border: 1px solid;
    text-align: center;
  }

  table, tr {
    width: 100%;
    border-collapse: collapse;
  }

  th {
    /*width: 16%;*/
  }

  td {
    padding: .3em;
  }
</style>